import React from "react";
import styled from "styled-components";

interface CircleProps {
  half?: boolean;
  size: number;
  rotate?: number;
  color: string;
  className?: string;
}

const StyledSvg = styled.svg.attrs<CircleProps>(({ half, size }) => ({
  version: "1.1",
  xmlns: "https://www.w3.org/2000/svg",
  width: size,
  height: half ? size / 2 : size,
}))<CircleProps>`
  fill: ${(props) => props.color};
  transform: rotate(${(props) => props.rotate}deg);
`;

export const Circle = (props: CircleProps) => {
  const { half, size, color, rotate } = {
    half: false,
    size: 100,
    color: "red",
    rotate: 0,
    ...props,
  };

  return (
    <StyledSvg
      half={half}
      size={size}
      color={color}
      rotate={rotate}
      className={props.className}
    >
      <circle cx={size / 2} cy={size / 2} r={size / 2} />
    </StyledSvg>
  );
};
